import { FunctionComponent } from "react";

import { Button } from "./styles";

interface IProps {
  onClick: () => void;
  id: string;
  Icon: React.ElementType;
}

const IconButton: FunctionComponent<IProps> = ({ Icon, onClick, id }) => {
  return (
    <Button data-testid={`icon-button-${id}`} onClick={onClick}>
      <Icon />
    </Button>
  );
};

export default IconButton;
